import { render, staticRenderFns } from "./table-orderer.vue?vue&type=template&id=8a86c4f6&scoped=true&"
import script from "./table-orderer.vue?vue&type=script&lang=js&"
export * from "./table-orderer.vue?vue&type=script&lang=js&"
import style0 from "./table-orderer.vue?vue&type=style&index=0&id=8a86c4f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a86c4f6",
  null
  
)

export default component.exports